class CollectionUserColumns extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.querySelector('#product-grid');
    this.columnButtons = this.querySelectorAll('.collection-user-columns__btn');
    this.layout = this.dataset.layout;

    this.defaultView = 'view-4-desktop';
    this.currentView = sessionStorage.getItem('collection-view') || this.defaultView;
    this.mobileBreakpoint = 750;

    this.init();

    window.addEventListener('resize', this.handleResize.bind(this));
    this.observeGridChanges();
  }

  observeGridChanges() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const observer = new MutationObserver(() => {
      this.productGrid = document.querySelector('#product-grid');
      if (this.productGrid) {
        this.applyView(this.currentView);
      }
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }

  init() {
    requestAnimationFrame(() => this.applyView(this.currentView));

    this.columnButtons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    const view = button.dataset.view;

    sessionStorage.setItem('collection-view', view);
    this.currentView = view;

    this.applyView(view);
  }

  handleResize() {
    this.applyView(this.currentView);
  }

  isMobile() {
    return window.innerWidth < this.mobileBreakpoint;
  }

  getMobileClassForView(desktopView) {
    const mobileMapping = {
      'view-3-desktop': 'grid--1-col',
      'view-4-desktop': 'grid--2-col',
      'view-6-desktop': 'grid--3-col'
    };
    return mobileMapping[desktopView] || 'grid--2-col';
  }

  applyView(view) {
    if (!this.productGrid) return;

    this.productGrid.classList.remove(
      'view-3-desktop',
      'view-4-desktop',
      'view-6-desktop',
      'grid--1-col',
      'grid--2-col',
      'grid--3-col'
    );

    if (this.isMobile()) {
      const mobileClass = this.getMobileClassForView(view);
      this.productGrid.classList.add(mobileClass);
    } else {
      this.productGrid.classList.add(view);
    }

    this.columnButtons.forEach((button) => {
      if (button.dataset.view === view) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    this.handleViewVisibility(view);

    window.dispatchEvent(new CustomEvent('collection:viewChanged'));
  }

  handleViewVisibility(view) {
    const isSimplifiedView = view === 'view-6-desktop';

    const banners = this.productGrid?.querySelectorAll('.collection-grid-banner-wrapper');
    banners?.forEach(banner => {
      banner.style.display = isSimplifiedView ? 'none' : '';
    });

    const quickAddButtons = this.productGrid?.querySelectorAll('.quick-add');
    quickAddButtons?.forEach(btn => {
      btn.style.display = isSimplifiedView ? 'none' : '';
    });

    const productCards = this.productGrid?.querySelectorAll('.card-information');
    productCards?.forEach(card => {
      card.style.display = isSimplifiedView ? 'none' : '';
    });

    const badges = this.productGrid?.querySelectorAll('.card__badge');
    badges?.forEach(badge => {
      badge.style.display = isSimplifiedView ? 'none' : '';
    });
  }
}

customElements.define('collection-user-columns', CollectionUserColumns);
